import {Component, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {Offer} from '../../../models/Offer';
import {OffersService} from '../../../services/offers/offers.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {MAP_STYLE} from './map-styles';
import {GoogleMap, MapInfoWindow} from '@angular/google-maps';

@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss'],
  animations: [
    trigger('slideInOutPreview', [
      transition(':enter', [
        style({transform: 'translateX(100%)'}),
        animate('200ms ease-out', style({transform: 'translate(0)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateX(100%)'}))
      ])
    ]),
    trigger('slideInOutFilter', [
      transition(':enter', [
        style({transform: 'translateX(-100%)'}),
        animate('200ms ease-out', style({transform: 'translate(0)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateX(-100%)'}))
      ])
    ])
  ],
})
export class GoogleMapsComponent implements AfterViewInit {
  @ViewChild(GoogleMap, {static: false}) gmap: GoogleMap;
  @ViewChild('tooltip') tooltip: ElementRef;
  mapCenter = {lat: 43.218473, lng: 27.909166};
  mapOptions = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    gestureHandling: 'cooperative',
    // @ts-ignore
    styles: MAP_STYLE
  };

  selectedOffer: Offer;

  tooltipInfo: string;
  filterOpen: boolean;

  constructor(public offS: OffersService) {
    this.filterOpen = false;
  }

  ngAfterViewInit() {
    if (this.offS.mapMarkers) {
      this.setupMarkers();
    } else {
      this.offS.getOffersForMap();
      this.offS.googleMapsReady.subscribe(() => {
        this.setupMarkers();
      });
    }
  }

  private setupMarkers() {
    for (let i = 0; i < this.offS.mapMarkers.length; i++) {
      const marker = this.offS.mapMarkers[i];
      const prop = this.offS.mapProperties[i];
      google.maps.event.clearListeners(marker, 'click');
      google.maps.event.clearListeners(marker, 'mouseover');
      google.maps.event.clearListeners(marker, 'mouseout');
      marker.setMap(this.gmap._googleMap);
      marker.addListener('click', (e) => {
        this.selectedOffer = prop;
      });
      marker.addListener('mouseover', (e) => {
        this.setOfferTooltip(prop, e);
      });
      marker.addListener('mouseout', () => {
        this.tooltip.nativeElement.style.display = 'none';
      });
    }
  }

  setOfferTooltip(offer: Offer, event: any) {
    this.tooltipInfo = offer.space + 'кв.м<br>€' + offer.price;
    // @ts-ignore
    const bounds = this.gmap._elementRef.nativeElement.getClientRects()[1];
    this.tooltip.nativeElement.style.left = event.pixel.x + bounds.width / 2 - 40 + 'px';
    this.tooltip.nativeElement.style.top = event.pixel.y + bounds.height / 2 - 110 + 'px';
    this.tooltip.nativeElement.style.display = 'block';
  }
}
